import { ICurrencyAccount } from '@/entities/currency-account';

import { ArrowDownBold } from '@/shared/assets';
import { cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

interface CurrencyAccountSelectTriggerProps {
  foundItem?: ICurrencyAccount;
  placeholder: string;
  isOpen: boolean;
}

export const CurrencyAccountSelectTrigger = ({
  foundItem,
  placeholder,
  isOpen,
}: CurrencyAccountSelectTriggerProps) => {
  return (
    <div
      className={cn(
        'peer flex h-[64px] w-full cursor-pointer items-center rounded-2xl bg-base-300 px-4 pt-[10px] text-sm outline-none duration-200 ease-in-out',
        'relative justify-start text-left font-normal',
        !foundItem && 'text-muted-foreground',
      )}
    >
      <Typography variant="16-r" className="peer flex items-center">
        {foundItem ? foundItem.currencyName : null}
      </Typography>
      <span
        className={cn(
          'pointer-events-none absolute left-4 top-[18px] origin-[0] -translate-y-3 scale-75 text-base text-base-300 duration-150 peer-empty:translate-y-0 peer-empty:scale-100 peer-focus:-translate-y-3 peer-focus:scale-75',
        )}
      >
        {placeholder}
      </span>
      <ArrowDownBold
        className="mb-[10px] ml-auto min-h-5 min-w-5"
        isActive={isOpen}
      />
    </div>
  );
};
